import { BetResponseCode, notificationStore } from '@pascal/pascal-core';
import { additionalBetAmountChangingButtons } from '../enums/uiConfig';
import {
  divide as divideNumbers,
  multiply as multiplyNumbers,
  plus as plusNumbers,
  minus as minusNumbers,
  toFixed,
} from './arithmeticOperations';

export const getValidatedBetAmount = (
  index,
  action,
  number,
  betAmount,
  limits,
  isDemo,
  balance,
  callback
  // otherSectionAmount
) => {
  const { maxBet, minBet, defaultBetAmount } = limits;
  const { divide, multiply, min, max, plus, minus } = additionalBetAmountChangingButtons;

  const mappingActionsByType = {
    [multiply]: () => {
      const condition = multiplyNumbers(betAmount, number) > maxBet;
      if (condition) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InValidMaxBet,
        });
      }

      return condition ? maxBet : multiplyNumbers(betAmount, number);
    },
    [plus]: () => {
      const condition = plusNumbers(betAmount, minBet) > maxBet;
      if (condition) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InValidMaxBet,
        });
      }

      return condition ? maxBet : plusNumbers(Number(betAmount), minBet);
    },
    [minus]: () => {
      const condition = minusNumbers(+betAmount, minBet) < minBet;
      if (condition) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InValidMinBet,
        });
      }
      return condition ? minBet : minusNumbers(betAmount, minBet);
    },
    [divide]: () => {
      const condition = divideNumbers(betAmount, number) < minBet;
      if (condition) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InValidMinBet,
        });
      }

      return condition ? minBet : divideNumbers(betAmount, number);
    },
    [min]: () => {
      if (balance < minBet && isDemo) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InsufficientFunds,
        });
      }
      return minBet || defaultBetAmount;
    },
    [max]: () => {
      if (isDemo && balance <= maxBet) {
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InsufficientFunds,
        });
      }
      return maxBet;
    },
  };
  const decidedAmount = mappingActionsByType?.[action]();

  // setTimeout(() => {
  //   if (betAmount !== toFixed(decidedAmount, 2)) {
  //     iframeService.sendStakeUpdate(plusNumbers(+decidedAmount, otherSectionAmount));
  //   }
  // }, 400);
  callback({ changeBet: toFixed(decidedAmount, 2), index });
};

export const checkDoBetModel = (limits, userBalance, amount, isDemo) => {
  let generatedBetResponseCode;
  if (Number(amount) < limits.minBet) {
    generatedBetResponseCode = BetResponseCode.InValidMinBet;
  } else if (Number(amount) > limits.maxBet) {
    generatedBetResponseCode = BetResponseCode.InValidMaxBet;
  }
  if (isDemo && Number(amount) > userBalance) {
    generatedBetResponseCode = BetResponseCode.InsufficientFunds;
  }
  return generatedBetResponseCode;
};
